import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { loginOrganization } from "../Actions/Organization/AuthActions";
import { AppDispatch } from "../store";
import { Link, useNavigate } from "react-router-dom";
import LoadingButton from "../Components/LoadingButton";
import Error from "../Components/Error";
import logo from "../Images/logo.png"
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const OrganizationLogin: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setErrror] = useState('');
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);

  const Login = async () => {
    try {
      const actionResponse = await dispatch(loginOrganization(email, password));
      if (actionResponse.success) {
        navigate('/');
      } else {
        setErrror(actionResponse.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const triggerLogin = async () => {
    setLoading(true);
    await Login();
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-brand-50 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        {/* Card */}
        <div className="bg-white rounded-3xl shadow-sm border border-brand-100 px-8 py-10">
          {/* Logo */}
          <div className="flex justify-center mb-8">
            <img src={logo} className="h-14 w-auto" alt="logo" />
          </div>

          <h2 className="text-2xl font-bold text-gray-900 text-center mb-1">{t("login")}</h2>
          <p className="text-sm text-gray-500 text-center mb-8">{t("notAMember")}{" "}
            <Link to="/Signup-org" className="text-brand-600 font-semibold hover:text-brand-700">
              {t("startFreeTrial")}
            </Link>
          </p>

          <form className="space-y-5" onSubmit={e => { e.preventDefault(); triggerLogin(); }}>
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1.5">
                {t("email")}
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                autoComplete="email"
                required
                className="w-full px-4 py-2.5 rounded-xl border border-gray-200 bg-gray-50 text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-400 focus:border-transparent transition"
              />
            </div>

            <div>
              <div className="flex items-center justify-between mb-1.5">
                <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                  {t("password")}
                </label>
                <Link to="/Forgot-org" className="text-xs text-brand-600 font-medium hover:text-brand-700">
                  {t("forgotPassword")}
                </Link>
              </div>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  autoComplete="current-password"
                  required
                  className="w-full px-4 py-2.5 rounded-xl border border-gray-200 bg-gray-50 text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-400 focus:border-transparent transition"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute inset-y-0 end-3 flex items-center text-gray-400 hover:text-gray-600"
                >
                  {showPassword ? <FaEyeSlash className="w-4 h-4" /> : <FaEye className="w-4 h-4" />}
                </button>
              </div>
            </div>

            {error && <Error message={error} />}

            <div className="pt-1">
              {loading
                ? <LoadingButton />
                : <button
                    type="submit"
                    className="w-full py-2.5 rounded-xl bg-brand-600 text-white text-sm font-semibold hover:bg-brand-700 focus:outline-none focus:ring-2 focus:ring-brand-400 focus:ring-offset-2 transition shadow-sm"
                  >
                    {t("login")}
                  </button>
              }
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default OrganizationLogin;
